// Declare gtag as a global function (loaded in index.html)
declare function gtag(...args: unknown[]): void;

/**
 * Send a custom event to Google Analytics 4.
 * Automatically appends page_location and page_path.
 */
export function trackGA4Event(eventName: string, params: Record<string, unknown> = {}) {
  if (typeof gtag !== "undefined") {
    gtag("event", eventName, {
      ...params,
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }
}
